import axios from 'axios';
import { axiosAuthInstance } from '../lib/axiosConfig';
import { isProductionEnvironment } from '../config';

export default class UserService {

  static login = (data: Object) => {
    return new Promise((resolve, reject) => {
      axiosAuthInstance
        .post('/auth/login', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static status = () => {
    if (isProductionEnvironment()) {
      return axiosAuthInstance.get('/auth/status')
      .then((res) => {
        return { ...res.data };
      }, (error) => {
        console.log(error);
      });
  }

    // Dev mode. Enter the email of the user you'd like to test.
    return axios.get('/users?email=superuser@lovelandguidebuilder.com')
      .then((res) => {
        return { ...res.data[0] };
      }, (error) => {
        console.log(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/services/UserService.ts